import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export async function fetchPath(id: any) {
  const { data } = await unauthenticatedHttp().get(
    `${window.env.API_UNAUTH}/paths/${id}?includeChild=true`
  );

  return data;
}
